<template>
  <div>
    <el-dialog
      title="发送邮件"
      center
      width="750px"
      :visible.sync="visible"
      @closed="onClosed"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="form" :model="form" label-width="160px" size="mini">
        <el-form-item label="标题和正文：">
          <mail-template
            v-model="form.mailTemplate"
            :readonly="isUsingExistedMailTemplate"
            style="width: 500px"
          ></mail-template>
        </el-form-item>
        <el-form-item label="按条件筛选玩家：">
          <el-switch
            v-model="form.isSelectPlayersByConditions"
            active-color="#13ce66"
          >
          </el-switch>
        </el-form-item>
        <div v-if="form.isSelectPlayersByConditions">
          <el-form-item label="目标分区：">
            <zone-selector
              placeholder="请选择"
              enableFullZones
              @ready="onZoneSelectorReady"
              @change="onZoneSelectorChange"
              ref="zoneSelector"
            >
            </zone-selector>
          </el-form-item>
          <el-form-item label="目标渠道：">
            <channel-selector
              placeholder="请选择"
              enableFullChannels
              @ready="onChannelSelectorReady"
              @change="onChannelSelectorChange"
              ref="channelSelector"
            >
            </channel-selector>
          </el-form-item>
        </div>
        <el-form-item
          label="玩家ID集合："
          v-show="!form.isSelectPlayersByConditions"
        >
          <el-input
            type="textarea"
            rows="5"
            v-model="form.uidList"
            placeholder="可放多个ID，每行放1个"
            style="width: 300px"
          ></el-input>
        </el-form-item>

        <el-form-item label="附件：" v-if="userRole != 'customerService'">
          <mail-attachment
            v-for="item of form.attachments"
            :key="item.seq"
            :availableAttachments="availableAttachments"
            v-model="item.data"
            @remove="removeAttachment(item.seq)"
          ></mail-attachment>
          <el-button @click="addNewAttachment()" class="el-icon-plus"
            >添加</el-button
          >

          <el-popover
            style="margin-left: 20px"
            placement="top-start"
            width="631"
            trigger="click"
          >
            <el-table border :data="propsTemplates" max-height="400px">
              <el-table-column
                align="center"
                width="200"
                property="label"
                label="名称"
              ></el-table-column>
              <el-table-column
                align="center"
                width="350"
                property="value"
                label="道具"
              >
                <template slot-scope="scope">
                  <div
                    v-for="(item, index) in JSON.parse(scope.row.value)"
                    :key="index"
                  >
                    {{
                      attachmentsForProps[item.id]
                        ? attachmentsForProps[item.id].name
                        : ""
                    }}
                    x {{ item.amount }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template slot-scope="scope">
                  <span
                    style="
                      padding-left: 10px;
                      color: rgb(37, 148, 240);
                      cursor: pointer;
                    "
                    @click="exportProp(scope.row)"
                    >导入</span
                  >
                </template>
              </el-table-column>
            </el-table>
            <el-button
              type="primary"
              plain
              slot="reference"
              icon="el-icon-download"
              >从模板导入</el-button
            >
          </el-popover>
        </el-form-item>

        <el-form-item label="定时发送：">
          <el-switch v-model="form.isSchedledMail" active-color="#13ce66">
          </el-switch>
        </el-form-item>
        <div v-if="isShowSatrtAndEndAt">
          <el-form-item label="开始定时：" prop="startAt">
            <el-date-picker
              v-model="form.startAt"
              type="datetime"
              :clearable="false"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束定时：" prop="endAt">
            <el-date-picker
              v-model="form.endAt"
              type="datetime"
              :clearable="false"
              placeholder="选择日期"
              format="yyyy-MM-dd HH:mm"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
        </div>
        <div v-if="form.isSchedledMail">
          <el-form-item label="定时时间类型：" prop="cycleType">
            <el-select
              style="width: 100px"
              @change="cycleTypeChange"
              v-model="form.cycleType"
              placeholder="请选择"
            >
              <el-option
                v-for="item in cycleTypeSelector"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="定时时间：" prop="cycle">
            <div v-if="form.cycleType == 0">
              <el-date-picker
                v-model="form.scheduledSendAt"
                type="datetime"
                :clearable="false"
                placeholder="选择日期"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
              >
              </el-date-picker>
            </div>
            <div v-else-if="form.cycleType == 1">
              <el-select
                style="width: 100px"
                v-model="cycleForm.cycle1"
                placeholder="几点"
              >
                <el-option
                  v-for="item in 24"
                  :key="item + $util.uuid()"
                  :label="`${item - 1}点`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 120px; margin-left: 3px"
                v-model="cycleForm.cycle1_1"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item + $util.uuid()"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
            <div v-else-if="form.cycleType == 2">
              <el-select
                style="width: 100px"
                v-model="cycleForm.cycle2"
                placeholder="周几"
              >
                <el-option
                  v-for="item in weekDay"
                  :key="item.value + $util.uuid()"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 100px; margin-left: 3px"
                v-model="cycleForm.cycle2_1"
                placeholder="几点"
              >
                <el-option
                  v-for="item in 24"
                  :key="item + $util.uuid()"
                  :label="`${item - 1}点`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 100px; margin-left: 3px"
                v-model="cycleForm.cycle2_2"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item + $util.uuid()"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
            <div v-else-if="form.cycleType == 3">
              <el-select
                style="width: 100px"
                v-model="cycleForm.cycle3"
                placeholder="几号"
              >
                <el-option
                  v-for="item in 31"
                  :key="item + $util.uuid()"
                  :label="`${item}号`"
                  :value="item"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 100px; margin-left: 3px"
                v-model="cycleForm.cycle3_1"
                placeholder="几点"
              >
                <el-option
                  v-for="item in 24"
                  :key="item + $util.uuid()"
                  :label="`${item - 1}点`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
              <el-select
                style="width: 100px; margin-left: 3px"
                v-model="cycleForm.cycle3_2"
                placeholder="几分"
              >
                <el-option
                  v-for="item in 60"
                  :key="item + $util.uuid()"
                  :label="`${item - 1}分`"
                  :value="item - 1"
                >
                </el-option>
              </el-select>
            </div>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button
          type="primary"
          v-if="form.isSchedledMail"
          icon="el-icon-alarm-clock"
          @click="submit()"
          >定时发送</el-button
        >
        <el-button
          type="primary"
          v-else
          icon="el-icon-s-promotion"
          @click="submit()"
          >立即发送</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";

import MailTemplate from "./MailTemplate.vue";
import MailAttachment from "./MailAttachment.vue";
import ChannelSelector from "@/components/ChannelSelector";
import ZoneSelector from "@/components/ZoneSelector";

export default {
  data() {
    return {
      visible: true,
      form: {
        mailTemplate: null,
        selectedZoneId: "",
        selectedChannelId: "",
        isSelectPlayersByConditions: false,
        isSchedledMail: false,
        scheduledSendAt: 0,
        uidList: "",
        attachments: [],
        cycleType: 0,
        cycle: 0,
        startAt: new Date().setHours(0, 0, 0, 0),
        endAt: new Date(
          new Date().setFullYear(
            new Date().getFullYear() + 10,
            new Date().getMonth(),
            new Date().getDate()
          )
        ).setHours(0, 0, 0, 0),
      },
      availableAttachments: [],
      attachmentSeq: 0,
      userRole: "",
      requestId: "",
      propsTemplates: [],
      attachmentsForProps: {},
      isShowSatrtAndEndAt: false,
      cycleForm: {
        cycle1: 0,
        cycle1_1: 0,
        cycle2: 1,
        cycle2_1: 0,
        cycle2_2: 0,
        cycle3: 1,
        cycle3_1: 0,
        cycle3_2: 0,
      },
      cycleTypeSelector: [
        {
          value: 0,
          label: "单次",
        },
        {
          value: 1,
          label: "每天",
        },
        {
          value: 2,
          label: "每周",
        },
        {
          value: 3,
          label: "每月",
        },
      ],
      weekDay: [
        {
          value: 1,
          label: "周一",
        },
        {
          value: 2,
          label: "周二",
        },
        {
          value: 3,
          label: "周三",
        },
        {
          value: 4,
          label: "周四",
        },
        {
          value: 5,
          label: "周五",
        },
        {
          value: 6,
          label: "周六",
        },
        {
          value: 7,
          label: "周日",
        },
      ],
    };
  },

  props: {
    value: Object,
  },

  components: {
    MailTemplate,
    MailAttachment,
    ChannelSelector,
    ZoneSelector,
  },

  async created() {
    // 给requestId赋值
    this.requestId = `admin-request-${util.uuid()}`;

    // 当前用户的角色
    {
      let loginUser = this.$bizutil.getLoginUser();
      if (loginUser) {
        this.userRole = loginUser.role;
      }
    }

    if (this.isUsingExistedMailTemplate) {
      this.form.mailTemplate = {
        languageTemplates: this.value.mailTemplate.languageTemplates,
      };
    } else {
      this.form.mailTemplate = {
        languageTemplates: [],
      };
    }

    await this.loadPropsTemplates();

    await this.loadAvailableAttachments();
  },

  computed: {
    isUsingExistedMailTemplate() {
      return !!this.value.mailTemplate;
    },
  },

  methods: {
    async onChannelSelectorReady() {
      this.$refs.channelSelector.channelId = this.form.selectedChannelId;
    },

    async onChannelSelectorChange(newChannelId, oldChannelId) {
      this.form.selectedChannelId = newChannelId;
    },

    async onZoneSelectorReady() {
      this.$refs.zoneSelector.zoneId = this.form.selectedZoneId;
    },

    async onZoneSelectorChange(newZoneId, oldZoneId) {
      this.form.selectedZoneId = newZoneId;
    },

    async loadPropsTemplates() {
      // 向服务器查询模板集合
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/queryMailPropsTemplate`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      let initlist = resData.data.list || [];

      for (let t of initlist) {
        this.propsTemplates.push({
          label: t.name,
          value: t.props,
        });
      }
    },

    async exportProp(e) {
      let props = JSON.parse(e.value);
      for (let item of props) {
        await this.addNewAttachment2(item.id, item.amount);
      }
    },

    /**
     * 查询可用附件集合
     */
    async loadAvailableAttachments() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/getAppendixList`,
          {
            isShowPayItem: false,
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message({
          message: resData.message,
          type: "error",
        });
        return;
      }

      for (let category of resData.data.categories) {
        this.availableAttachments.push({
          label: category.name,
          value: category.name,
          children: (() => {
            let result = [];
            for (let e of category.entries) {
              this.attachmentsForProps[e.id] = {
                name: e.name,
                type: category.name,
              };
              result.push({
                label: e.name,
                value: e.id,
              });
            }
            return result;
          })(),
        });
      }
    },

    /**
     * 增加一个附件
     */
    addNewAttachment() {
      this.form.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [],
          number: 1,
        },
      });
    },

    /**
     * 增加一个附件
     */
    async addNewAttachment2(itemId, amount) {
      this.form.attachments.push({
        seq: ++this.attachmentSeq,
        data: {
          valuesOfNodes: [this.attachmentsForProps[itemId].type, itemId],
          number: amount,
        },
      });
    },

    /**
     * 删除一个附件
     */
    removeAttachment(seq) {
      for (let i = 0; i < this.form.attachments.length; i++) {
        if (this.form.attachments[i].seq == seq) {
          this.form.attachments.splice(i, 1);
          break;
        }
      }
    },

    /**
     * 提交表单
     */
    async submit() {
      let selectedZoneId = 0;
      let selectedChannelId = 0;
      let uidList = [];

      let mailTemplateId = "0";
      let mailLanguageTemplates = null;
      let scheduledSendAt = "0";
      if (this.isUsingExistedMailTemplate) {
        mailTemplateId = this.value.mailTemplate.mailTemplateId;
      } else {
        mailLanguageTemplates = this.form.mailTemplate.languageTemplates;

        // 确保在各语言的模板中，至少有1个语言模板的标题不是空的
        {
          let isAnyLanguageTemplateTitleValid = false;

          for (let languageTemplate of mailLanguageTemplates) {
            if (languageTemplate.title.trim() != "") {
              isAnyLanguageTemplateTitleValid = true;
              break;
            }
          }

          if (!isAnyLanguageTemplateTitleValid) {
            this.$message({
              message: "请至少为1个语言模板填写有效标题",
              type: "error",
            });
            return;
          }
        }
      }
      let cycle = 0;
      let cycleType = 0;
      if (this.form.isSchedledMail) {
        cycleType = this.form.cycleType;
        if (cycleType == 0) {
          if (this.form.scheduledSendAt <= new Date().getTime()) {
            this.$alert("定时时间必须在当前时间之后", "提示", {
              confirmButtonText: "确定",
            });
            return;
          }
          scheduledSendAt = String(this.form.scheduledSendAt);
        } else if (cycleType == 1) {
          let cycle1 = Number(this.cycleForm.cycle1);
          let cycle1_1 = Number(this.cycleForm.cycle1_1);
          cycle = cycle1 * 60 + cycle1_1;
        } else if (cycleType == 2) {
          let cycle2 = Number(this.cycleForm.cycle2);
          let cycle2_1 = Number(this.cycleForm.cycle2_1);
          let cycle2_2 = Number(this.cycleForm.cycle2_2);

          cycle = (cycle2 - 1) * 24 * 60 + cycle2_1 * 60 + cycle2_2;
        } else if (cycleType == 3) {
          let cycle3 = Number(this.cycleForm.cycle3);
          let cycle3_1 = Number(this.cycleForm.cycle3_1);
          let cycle3_2 = Number(this.cycleForm.cycle3_2);

          cycle = (cycle3 - 1) * 24 * 60 + cycle3_1 * 60 + cycle3_2;
        }
      }

      let text = "";

      if (this.form.isSelectPlayersByConditions) {
        text = "即将发送一封大范围邮件，确定吗？";
        // 必须选择目标分区
        if (this.form.selectedZoneId === "") {
          this.$message({
            message: "请选择目标分区",
            type: "error",
          });
          return;
        }

        selectedZoneId = parseInt(this.form.selectedZoneId);

        // 必须选择目标渠道
        if (this.form.selectedChannelId === "") {
          this.$message({
            message: "请选择目标渠道",
            type: "error",
          });
          return;
        }

        selectedChannelId = parseInt(this.form.selectedChannelId);
      } else {
        let parseResult = this.parseUidList();
        if (parseResult.err) {
          this.$message({
            message: parseResult.err,
            type: "error",
          });
          return;
        }

        uidList = parseResult.list;
      }

      if (this.form.isSchedledMail) {
        text = "即将创建一封定时邮件";
      }

      try {
        if (text.length > 0) {
          await this.$confirm(text, "警告", {
            type: "warning",
            confirmButtonText: "确定",
            cancelButtonText: "取消",
          });
        }
      } catch (e) {
        return;
      }

      let attachments = [];
      for (let e of this.form.attachments) {
        if (e.data.valuesOfNodes.length == 0) {
          this.$message({
            message: "请正确选择附件",
            type: "error",
          });
          return;
        }

        let id = e.data.valuesOfNodes[1];
        let num = e.data.number;
        attachments.push({
          id: id,
          num: num,
          valuesOfNodes: e.data.valuesOfNodes,
        });
      }

      let startAt = new Date(this.form.startAt).setSeconds(0, 0);
      let endAt = new Date(this.form.endAt).setSeconds(59, 999);

      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/sendMail`,
          {
            mailTemplateId: mailTemplateId,
            mailLanguageTemplates: mailLanguageTemplates,
            zoneId: selectedZoneId,
            channelId: selectedChannelId,
            isProvideAll: this.form.isSelectPlayersByConditions,
            uidList: uidList,
            props: JSON.stringify(attachments),
            scheduledSendAt: scheduledSendAt,
            cycleType: cycleType,
            cycle: cycle,
            startAt: String(startAt),
            endAt: String(endAt),
          },
          {
            headers: {
              token: bizutil.getLoginUserToken(),
              requestId: this.requestId,
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      this.$message({
        message: "发送成功",
        type: "success",
      });

      // 关闭当前对话框
      this.visible = false;
    },

    /**
     * 解析玩家ID集合
     *
     * @returns {list: [], err: "xxxx"}
     */
    parseUidList() {
      let list = [];

      let uidListStr = this.form.uidList.trim();
      if (uidListStr.length > 0) {
        let arr = uidListStr.split(/\s+/);
        for (let e of arr) {
          let uid = Number(e);
          if (isNaN(uid) || uid != parseInt(uid)) {
            return {
              list: [],
              err: "玩家ID格式错误",
            };
          }

          if (uid <= 0) {
            return {
              list: [],
              err: "玩家ID必须是正整数",
            };
          }

          list.push(uid);
        }
      }

      if (list.length == 0) {
        return {
          list: [],
          err: "请输入玩家ID",
        };
      }

      return {
        list: list,
      };
    },

    async cycleTypeChange(e) {
      if (e == 0) {
        this.isShowSatrtAndEndAt = false;
      } else {
        this.isShowSatrtAndEndAt = true;
      }
    },
    formatSimpleTime(val) {
      let v = parseInt(val);
      if (v < 10) {
        return "0" + v;
      }
      return v;
    },
    onClosed() {
      // 向父组件抛出事件
      this.$emit("close");
    },
  },
};
</script>


<style lang="scss" scoped>
</style>